// extracted by mini-css-extract-plugin
module.exports = {"header":"DaMRS","logo":"f5oMq","locationCard":"zAtp4","card":"Hf7fD","address":"Ny7fv","scheduleLater":"UTKdP","order-button":"-8eLs","order-button-closed":"kmIjv","info":"UMY2r"};